import { ObjectStoreStats } from '#object-store/types';
export class InitializationStats {
    objectStoreStats;
    constructor(log) {
        this.objectStoreStats = new ObjectStoreStats(log);
    }
}
